import React from 'react';
import { Tooltip, TooltipProps } from '@globalvisioninc/ui/tooltip';
import styles from './GVTooltip.module.css';

export interface GVTooltipProps extends TooltipProps {
  children: React.ReactElement<any, any>;
  title: NonNullable<React.ReactNode>;
  align?: 'center' | 'start' | 'end';
  side?: 'bottom' | 'left' | 'right' | 'top';
  disableHoverListener?: boolean;
  className?: string;
  sideOffset?: number;
  container?: HTMLElement | null;
  id?: string;
  arrow?: boolean;
  delayDuration?: number;
}

const GVTooltip = (props: GVTooltipProps) => {
  const {
    children,
    title,
    disableHoverableContent = false,
    disableHoverListener = false,
    className = styles.tooltip,
    side = 'top',
    align,
    sideOffset = 14,
    id,
    container,
    arrow = false,
    isOpen,
    onOpenChange,
    delayDuration,
    ...otherProps
  } = props;

  return (
    <Tooltip.Root
      disableHoverableContent={disableHoverableContent}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      delayDuration={delayDuration}
      {...otherProps}
    >
      <Tooltip.Trigger asChild className={styles.trigger}>
        {children}
      </Tooltip.Trigger>
      {disableHoverListener || !title ? null : (
        <Tooltip.Portal container={container}>
          <Tooltip.Content
            data-testid="gv-tooltip"
            side={side}
            align={align}
            sideOffset={sideOffset}
            className={className}
            id={id}
            collisionPadding={6}
          >
            {arrow ? <Tooltip.Arrow /> : null}
            {title}
          </Tooltip.Content>
        </Tooltip.Portal>
      )}
    </Tooltip.Root>
  );
};

export default GVTooltip;
